import { useState } from 'react'

export function ExpandableText({ text, maxLength = 15, expandable = true }) {
  const [isExpanded, setIsExpanded] = useState(false)
  if (!text) return '-'

  const isLong = text.length > maxLength
  const displayText =
    !isExpanded && isLong ? text.substring(0, maxLength) + '...' : text

  if (!isLong) {
    return (
      <span className="text-sm font-medium truncate block min-w-0" title={text}>
        {text}
      </span>
    )
  }

  if (!expandable) {
    return (
      <span
        className="text-sm font-medium cursor-help truncate block min-w-0"
        title={text}
      >
        {displayText}
      </span>
    )
  }

  return (
    <button
      type="button"
      onClick={() => setIsExpanded(!isExpanded)}
      className={`text-sm font-medium text-left hover:text-indigo-600 transition-colors block w-full ${isExpanded ? 'break-words whitespace-normal' : 'truncate min-w-0'}`}
      title={!isExpanded ? 'Click to view full text' : 'Click to collapse'}
    >
      {displayText}
    </button>
  )
}
